// Errors
export const ERROR_EXPORT_CALL_RECORDINGS = 'Failed to export call recordings. Please try again later.'
export const ERROR_EXPORT_CAMPAIGN_REPORT = 'Failed to export report. Please try again later.'
export const ERROR_EXPORT_ORG_REPORT = 'Failed to export Spending report. Please try again later.'
export const ERROR_EXPORT_SMS_REPORT = 'Failed to export SMS report. Please try again later.'
export const ERROR_GET_REPORT =
  'We could not find this report. It may have been deleted, or you lack permission to access it.'

// Messages
export const EXPORT_CALL_RECORDINGS_PENDING =
  'Your recordings ZIP is being prepared. Keep this app open to receive the download notification.'
export const EXPORT_ORG_REPORT_PENDING =
  'Your Spending report is being generated. You will receive a notification when done. Or you can find the completed report under Reports > Spend Reports.'
export const EXPORT_CAMPAIGN_REPORT_PENDING =
  'Your campaign report is being generated. You will receive a notification when done. Or you can find the completed report under Reports > Campaign Reports.'
export const EXPORT_SMS_REPORT_PENDING =
  'Your SMS report is being generated. You will receive a notification when done. Or you can find the completed report under Reports > Deliverability Reports.'
